import React from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  ButtonIcon,
  Checkbox2
} from '../../../components'
import Style from './style'
import { CREATE_DEFAULT, CREATE_BOOKING, getLocaleDateTimeString } from '../../../helpers'

const defaultFunction = () => {}
const defaultList = []

class CateringModal extends React.Component {
  constructor (props) {
    super(props)
    const {
      orderList,
      itemList
    } = props
    this.state = {
      selectedMenu: 0,
      lastMenuIndex: props.menuList.length - 1,
      orderList: orderList.map((order) => {
        return {
          ...order
        }
      }),
      itemList: { ...itemList },
      disabledCancleBtn: true
    }
  }

  isAnyChecked () {
    const { orderList } = this.state
    return orderList.some((order) => order.items.some((item) => item.isChecked))
  }

  isAnyWaiting () {
    const { orderList } = this.state
    const { status } = this.props
    return orderList.some((order) => order.status === 1 && status !== 0)
  }

  handleClearOrder () {
    const orderList = this.state.orderList.slice()
    const leftOverOrder = []
    for (const order of orderList) {
      if (order.status > 0) {
        const items = order.items
        const leftOverItem = []
        for (const item of items) {
          if (!item.isChecked) {
            leftOverItem.push(item)
          }
        }
        order.items = leftOverItem
        leftOverOrder.push(order)
      } else {
        leftOverOrder.push(order)
      }
    }
    this.setState({
      orderList: leftOverOrder
    })
  }

  toggleDropDown (event) {
    const selectedNode = event.target.parentNode.parentNode.parentNode
    // const parentNode = selectedNode.parentNode
    // parentNode.childNodes.forEach((node) => {
    //   node.classList.toggle('show', false)
    // })
    selectedNode.classList.toggle('show')
  }

  handleTabChange (index) {
    this.setState({
      selectedMenu: index
    })
  }

  handlePlusItem (itemIndex, amount) {
    const { itemList, selectedMenu } = this.state
    const items = itemList[selectedMenu].slice()
    items[itemIndex] = {
      ...items[itemIndex],
      amount: amount + 1
    }
    itemList[selectedMenu] = items
    this.setState({
      itemList: itemList
    })
  }

  handleMinusItem (itemIndex, amount) {
    if (amount > 0) {
      const { itemList, selectedMenu } = this.state
      const items = itemList[selectedMenu].slice()
      items[itemIndex] = {
        ...items[itemIndex],
        amount: amount - 1
      }
      itemList[selectedMenu] = items
      this.setState({
        itemList: itemList
      })
    }
  }

  handlePlusOrder (orderIndex, itemIndex, amount) {
    const { orderList } = this.state
    const items = orderList[orderIndex].items.slice()
    items[itemIndex] = {
      ...items[itemIndex],
      amount: amount + 1
    }
    orderList[orderIndex].items = items
    this.setState({
      orderList: orderList
    })
  }

  handleMinusOrder (orderIndex, itemIndex, amount) {
    if (amount > 0) {
      const { orderList } = this.state
      const items = orderList[orderIndex].items.slice()
      items[itemIndex] = {
        ...items[itemIndex],
        amount: amount - 1
      }
      orderList[orderIndex].items = items
      this.setState({
        orderList: orderList
      })
    }
  }

  handleCheck (orderIndex, itemIndex) {
    const { orderList } = this.state
    const items = orderList[orderIndex].items.slice()
    items[itemIndex] = {
      ...items[itemIndex],
      isChecked: !items[itemIndex].isChecked
    }
    const isCheckedAll = items.every((item) => item.isChecked)
    orderList[orderIndex] = {
      ...orderList[orderIndex],
      isChecked: isCheckedAll,
      items: items
    }
    this.setState({
      orderList: orderList,
      disabledCancleBtn: !this.isAnyChecked()
    })
  }

  handleCheckAll (orderIndex) {
    const { orderList } = this.state
    let items = orderList[orderIndex].items.slice()
    const isCheckedAll = items.every((item) => item.isChecked)
    items = items.map((item) => {
      return {
        ...item,
        isChecked: !isCheckedAll
      }
    })
    orderList[orderIndex] = {
      ...orderList[orderIndex],
      isChecked: !isCheckedAll,
      items: items
    }
    this.setState({
      orderList: orderList,
      disabledCancleBtn: !this.isAnyChecked()
    })
  }

  renderListWoChkbox (index, id, label, amount, handlePlus, handleMinus) {
    return (
      <section
        className='item-container flex-vertical row-order'
        key={id}
      >
        <article className='row-order'>
          <section className='flex-horizontal flex-two hidden-overflow'>
            <label className='flex-one text-data no-margin color-black hidden-overflow text-ellipsis'>{label}</label>
          </section>
          <section className='flex-horizontal flex-one row-order'>
            <ButtonIcon
              onClick={() => handleMinus(index, amount)}
              className='catering-btn flex-zero round'
              icon='minus-solid.svg'
            />
            <label className='count-unit text-data color-black'>{amount}</label>
            <ButtonIcon
              onClick={() => handlePlus(index, amount)}
              className='catering-btn flex-zero round'
              icon='plus-solid.svg'
            />
          </section>
        </article>
      </section>
    )
  }

  renderListWChkbox (index, id, label, amount, checkValue, handlePlus, handleMinus, handleCheck) {
    const { status } = this.props 
    return (
      <section
        className='item-container flex-vertical'
        key={id}
      >
        <article className='flex-horizontal'>
          <section className='flex-horizontal flex-two no-margin no-padding hidden-overflow'>
            <Checkbox2
              className='order-item'
              handleClick={() => handleCheck(index)}
              value={checkValue}
              disabled={ status === 0 }
            />
            <label className='flex-one text-data no-margin color-black hidden-overflow text-ellipsis'>{ label }</label>
          </section>
          <section className='flex-horizontal flex-one no-margin no-padding'>
            {
              status !== 0 &&
              <ButtonIcon
                onClick={() => handleMinus(index, amount)}
                className='catering-btn flex-zero round'
                icon='minus-solid.svg'
              />
            }
            <label className='count-unit text-data color-black'>{amount}</label>
            {
              status !== 0 &&
              <ButtonIcon
              onClick={() => handlePlus(index, amount)}
              className='catering-btn flex-zero round'
              icon='plus-solid.svg'
            />
            }
          </section>
        </article>
      </section>
    )
  }

  renderPureList (index, id, label, amount) {
    return (
      <section
        className='item-container flex-vertical'
        key={id}
      >
        <hr className='gap' />
        <article className='flex-horizontal'>
          <label className='text-data no-margin color-black flex-two hidden-overflow text-ellipsis'>{ label }</label>
          <label className='count-unit text-data padding-right-34 color-black flex-one'>{ amount }</label>
        </article>
      </section>
    )
  }

  _renderOrder (index, id, createdAt, orderNumber, status, items, isChecked, language, drawLine) {
    const handlePlus = (itemIndex, amount) => this.handlePlusOrder(index, itemIndex, amount)
    const handleMinus = (itemIndex, amount) => this.handleMinusOrder(index, itemIndex, amount)
    const handleCheck = (itemIndex) => this.handleCheck(index, itemIndex)
    return (
      <section
        className='flex-vertical column-nowrap'
        key={id}
      >
        <section
          className='order-container'
          key={id}
        >
          <section className='order-header'>
            <label className='flex-one'>{getLocaleDateTimeString(new Date(createdAt), language)}</label>
            <label className='flex-one'>{CREATE_BOOKING.ORDER[language]} #{orderNumber}</label>
            <label className={`flex-one ${CREATE_BOOKING.ORDER_STATUS_TEXT[status].EN}`}>
              {CREATE_DEFAULT.STATUS[language]}: {CREATE_BOOKING.ORDER_STATUS_TEXT[status][language]}
            </label>
            <ButtonIcon
              className='catering-btn flex-zero round dropdown-btn'
              icon='sort.svg'
              onClick={(event) => this.toggleDropDown(event)}
            />
          </section>
          {
            status === 1 &&
              <Checkbox2
                label={CREATE_DEFAULT.ALL[language]}
                handleClick={() => this.handleCheckAll(index)}
                value={isChecked}
                className='flex-zero'
                containerClassName='no-margin-x-right'
              />
          }
          <section className='list-container flex-vertical'>
            {
              status === 1
                ? items.map((item, index) => this.renderListWChkbox(
                  index,
                  item.itemId,
                  item.itemName,
                  item.amount,
                  Boolean(item.isChecked),
                  handlePlus,
                  handleMinus,
                  handleCheck
                ))
                : items.map((item, index) => this.renderPureList(
                  index,
                  item.itemId,
                  item.itemName,
                  item.amount
                ))
            }
          </section>
        </section>
        {
          drawLine &&
            <hr className='seperator' />
        }
      </section>
    )
  }

  renderOrder (orderList) {
    const language = this.props.language
    const orderLength = orderList.length - 1
    return (
      <section
        className='flex-vertical overflowY-scroll full-height'
      >
        {orderList.map((order, index) => {
          const drawLine = index < orderLength
          return this._renderOrder(
            index,
            order.orderId,
            order.createdAt,
            order.orderNumber,
            order.status,
            order.items,
            Boolean(order.isChecked),
            language,
            drawLine
          )
        })}
      </section>
    )
  }

  renderList (itemList) {
    const handlePlus = (item, amount) => this.handlePlusItem(item, amount)
    const handleMinus = (item, amount) => this.handleMinusItem(item, amount)
    return (
      <section className='flex-vertical overflowY-scroll full-height'>
        {
          itemList.map((item, index) => this.renderListWoChkbox(
            index,
            item.itemId,
            item.itemName,
            item.amount,
            handlePlus,
            handleMinus
          ))
        }
      </section>
    )
  }

  _renderMenu (menu, index, language) {
    const isActive = this.state.selectedMenu === index ? 'active-' : ''
    if (!menu) {
      return (
        <div
          className={`${isActive}menu`}
          key={`blank${index}`}
        />
      )
    }
    return (
      <div
        className={`${isActive}menu`}
        onClick={() => this.handleTabChange(index)}
        key={menu.EN}
      >
        <div className='top-menu'>
          {menu[language]}
          <div className={`${isActive}border-menu`} />
        </div>
      </div>
    )
  }

  renderMenu (menuList) {
    const language = this.props.language
    return (
      <section className='menu-container'>
        <section className='flex-horizontal flex-zero space-between'>
          {
            menuList.map((menu, index) => this._renderMenu(menu, index, language))
          }
        </section>
        <hr className='header-line' />
      </section>
    )
  }

  renderBtn (btnList) {
    const { 
      language, 
      handleBackBtn, 
      handleSaveBtn, 
      handleDoneBtn, 
      handleCancelBtn 
    } = this.props

    return (
      <section className='flex-horizontal space-evenly flex-zero div-footer align-center'>
        {
          btnList.map((btn) => {
            let handleClick = null
            let disabled = false
            switch (btn.mode) {
              case 0:
                handleClick = () => handleSaveBtn(this.state.orderList)
                disabled = !this.isAnyWaiting()
                break
              case 1:
                handleClick = () => handleDoneBtn(this.state.itemList)
                break
              case 2:
                handleClick = () => handleCancelBtn(this.state.orderList)
                disabled = this.state.orderList.length === 0 || this.state.disabledCancleBtn
                break
              case 3:
              default:
                handleClick = () => handleBackBtn()
                break
            }
            return (
              <Button
                key={btn.name.EN}
                name={btn.name[language]}
                onClick={handleClick}
                className={`btn ${btn.className}`}
                disabled={disabled}
              />
            )
          })
        }
      </section>
    )
  }

  render () {
    const { selectedMenu, lastMenuIndex, orderList, itemList } = this.state
    const { labelHeader, menuList, btnList, btnListOrder, language, colorTheme } = this.props
    let bodyRenderer = defaultFunction
    let buttonList = defaultList
    if (selectedMenu === lastMenuIndex) {
      bodyRenderer = () => this.renderOrder(orderList)
      buttonList = btnListOrder
    } else {
      bodyRenderer = () => this.renderList(itemList[selectedMenu])
      buttonList = btnList
    }
    return (
      <Style colorTheme={colorTheme}>
        <div className='modal-container'>
          <h1 className='header-text'>
            {labelHeader[language]}
          </h1>
          {this.renderMenu(menuList)}
          {bodyRenderer()}
          {this.renderBtn(buttonList)}
        </div>
      </Style>
    )
  }
}

CateringModal.propTypes = {
  setAmount: PropTypes.func,
  handleBackBtn: PropTypes.func,
  handleDoneBtn: PropTypes.func,
  handleSaveBtn: PropTypes.func,
  updateOrder: PropTypes.func,
  itemList: PropTypes.shape(),
  menuList: PropTypes.array,
  orderList: PropTypes.array,
  btnList: PropTypes.array,
  btnListOrder: PropTypes.array,
  labelHeader: PropTypes.shape(),
  language: PropTypes.string
}

export default CateringModal
